import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  daysAroundDate: {
    defaultMessage: '<daysInput></daysInput> days <dateTypeDropdown></dateTypeDropdown>',
    description: 'Automation rule action input for setting days before or after a certain type of date. Example: 2 days after order date',
    id: 'BaCevE',
  },
  afterOrderDate: {
    defaultMessage: 'after Order Date',
    description: 'Dropdown option for setting days after order date',
    id: 'lMvCHc',
  },
  beforeDeliverByDate: {
    defaultMessage: 'before Deliver By Date',
    description: 'Dropdown option for setting days before deliver by date',
    id: 'L0jnPH',
  },
});
